export default __webpack_public_path__ + "static/media/google.9ed4ec0f.svg";